<template>
  <div
    id="email-nav"
  >
    <nav class="public-nav nav">
      <ul>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{
              name: 'create_email'
            }"
          >
            Create An Email
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="emailId"
        >
          <router-link
            class="nav-link"
            :to="{
              name: 'email',
              params: {
                emailId: emailId
              }
            }"
          >
            View Email
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="emailId"
        >
          <router-link
            class="nav-link"
            :to="{
              name: 'edit_email',
              params: {
                emailId: emailId
              }
            }"
          >
            Edit Email
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="emailId"
        >
          <router-link
            class="nav-link"
            :to="{
              name: 'email_recipients',
              params: {
                emailId: emailId
              }
            }"
          >
            Recipients
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="emailId"
        >
          <router-link
            class="nav-link"
            :to="{
              name: 'email_stats',
              params: {
                emailId: emailId
              }
            }"
          >
            Stats
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    emailId: {
      type: [ Number, String ],
      default: undefined
    }
  }
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>




// WEBPACK FOOTER //
// src/components/EmailNav.vue